import { useLocation } from 'react-router-dom';

export function getTransitsFilters() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const start = params.get('filter[start]');
  const end = params.get('filter[end]');

  return {
    start: start ? Number(start) : null,
    end: end ? Number(end) : null,
  };
}

export const buildTransitsUrl = (plate: string, start: number | null, end: number | null) => {
  const params = new URLSearchParams();

  params.set('sort[key]', 'datetime');
  params.set('sort[value]', 'descend');
  params.set('page', '1');

  if (start) params.set('filter[start]', String(start));
  if (end) params.set('filter[end]', String(end));

  params.set('filter[plate]', plate);
  params.set('filter[plateRecognized]', 'true');

  return `/transits/archive/wim?${params.toString()}`;
};
